import styled, { css } from 'styled-components';

interface DayProps {
  isSelected: boolean;
  isActive: boolean;
  day: {
    dayLabel: string;
    date: Date;
  };
  onClick: () => void;
}

const DayButton = styled.button<{ $isSelected: boolean; $isActive: boolean }>`
  margin: 0;
  border-radius: 50%;
  border: none;
  outline: none;
  width: 3.1rem;
  height: 3.1rem;
  background-color: ${({ theme }) => theme.palette.white};
  color: ${({ theme }) => theme.palette.black};
  font-weight: 600;
  cursor: pointer;
  transition: 0.2s all;

  ${({ theme, $isSelected = false }) =>
    $isSelected &&
    css`
      background-color: ${theme.palette.primary};
      color: ${theme.palette.white};
      font-weight: 400;
    `}

  ${({ theme, $isActive }) =>
    $isActive &&
    css`
      &:hover {
        background-color: ${theme.palette.primary};
        color: ${theme.palette.white};
        font-weight: 400;
      }
    `}
`;

export const Day = ({ day, onClick, isActive, isSelected }: DayProps): JSX.Element => (
  <DayButton
    disabled={!isActive}
    $isActive={isActive}
    $isSelected={isSelected}
    onClick={onClick}
    type="button"
    aria-label={day.dayLabel}
  >
    {Number(day.dayLabel)}
  </DayButton>
);
